"use strict";
// AUTO-GENERATED from contracts/markets/programs/markets/src/error/*.rs
// via scripts/generate-error-package.ts.
// Do NOT edit by hand — run `pnpm --filter @morfi/errors run generate` after a contract error change.
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPINION_ERROR_BY_CODE = exports.OPINION_ERRORS = void 0;
exports.parseOpinionError = parseOpinionError;
exports.isOpinionError = isOpinionError;
exports.OPINION_ERRORS = {
    Unauthorized: {
        code: 6000,
        name: 'Unauthorized',
        msg: 'caller is not authorized for this admin operation',
        module: 'admin',
    },
    UnauthorizedAdmin: {
        code: 6001,
        name: 'UnauthorizedAdmin',
        msg: 'authority is not authorized for this admin role',
        module: 'admin',
    },
    InvalidFeeSplit: {
        code: 6002,
        name: 'InvalidFeeSplit',
        msg: 'fee split must sum to 10_000',
        module: 'admin',
    },
    InvalidLabel: {
        code: 6003,
        name: 'InvalidLabel',
        msg: 'label invalid (interior NUL or non-ASCII)',
        module: 'admin',
    },
    ConfigBoundsViolation: {
        code: 6004,
        name: 'ConfigBoundsViolation',
        msg: 'config bounds violated',
        module: 'admin',
    },
    InvalidMintOwner: {
        code: 6005,
        name: 'InvalidMintOwner',
        msg: 'Invalid mint owner — expected classic SPL Token program',
        module: 'admin',
    },
    MetadataTooLong: {
        code: 6006,
        name: 'MetadataTooLong',
        msg: 'metadata payload exceeds caps',
        module: 'admin',
    },
    MetadataUriTooLong: {
        code: 6007,
        name: 'MetadataUriTooLong',
        msg: 'metadata uri exceeds 200 bytes or contains non-ASCII-printable bytes',
        module: 'admin',
    },
    InvalidTicker: {
        code: 6008,
        name: 'InvalidTicker',
        msg: 'ticker is empty, exceeds its byte cap, or contains invalid characters',
        module: 'admin',
    },
    NotImplemented: {
        code: 6100,
        name: 'NotImplemented',
        msg: 'instruction handler is not yet implemented',
        module: 'lifecycle',
    },
    InvalidOutcomeCount: {
        code: 6101,
        name: 'InvalidOutcomeCount',
        msg: 'invalid n_outcomes for market config bounds',
        module: 'lifecycle',
    },
    OutOfOrderOutcomeInit: {
        code: 6102,
        name: 'OutOfOrderOutcomeInit',
        msg: 'outcome_index must equal outcomes_initialized_count',
        module: 'lifecycle',
    },
    InvalidMarketState: {
        code: 6103,
        name: 'InvalidMarketState',
        msg: 'market is not in the required state for this instruction',
        module: 'lifecycle',
    },
    MarketNotResolved: {
        code: 6104,
        name: 'MarketNotResolved',
        msg: 'market is not Resolved',
        module: 'lifecycle',
    },
    MarketNotGraduated: {
        code: 6105,
        name: 'MarketNotGraduated',
        msg: 'market is not Graduated',
        module: 'lifecycle',
    },
    BondingCurvesNotClosed: {
        code: 6106,
        name: 'BondingCurvesNotClosed',
        msg: 'bonding_curves_closed is false (close_market_and_sweep_residue requires bonding-curve close first)',
        module: 'lifecycle',
    },
    BcQuoteVaultPdaMismatch: {
        code: 6107,
        name: 'BcQuoteVaultPdaMismatch',
        msg: 'bc_quote_vault key does not match the canonical PDA',
        module: 'lifecycle',
    },
    AmountBelowMinimum: {
        code: 6200,
        name: 'AmountBelowMinimum',
        msg: 'amount below minimum',
        module: 'trading',
    },
    SlippageExceeded: {
        code: 6201,
        name: 'SlippageExceeded',
        msg: 'trade output below caller minimum (slippage)',
        module: 'trading',
    },
    ZeroProgress: {
        code: 6202,
        name: 'ZeroProgress',
        msg: 'zero progress (zero output / zero delta)',
        module: 'trading',
    },
    BondingCurveClosed: {
        code: 6203,
        name: 'BondingCurveClosed',
        msg: 'bonding curve is closed for trade',
        module: 'trading',
    },
    OutcomeAccountMismatch: {
        code: 6204,
        name: 'OutcomeAccountMismatch',
        msg: "remaining-account vault does not match outcome's pinned BC vault",
        module: 'trading',
    },
    InvalidConvictionValue: {
        code: 6205,
        name: 'InvalidConvictionValue',
        msg: 'conviction value cannot be encoded in event snapshot',
        module: 'trading',
    },
    InvalidPostTradeReserves: {
        code: 6206,
        name: 'InvalidPostTradeReserves',
        msg: 'post-trade quote reserves cannot be encoded in event snapshot',
        module: 'trading',
    },
    SameTransferAccount: {
        code: 6207,
        name: 'SameTransferAccount',
        msg: 'token transfer source and destination must be different accounts',
        module: 'trading',
    },
    LoserNotDrained: {
        code: 6300,
        name: 'LoserNotDrained',
        msg: 'loser quote vault must be drained before graduation',
        module: 'resolution',
    },
    GraduationDelayNotElapsed: {
        code: 6301,
        name: 'GraduationDelayNotElapsed',
        msg: 'graduation delay not elapsed',
        module: 'resolution',
    },
    PrizePoolBelowThreshold: {
        code: 6302,
        name: 'PrizePoolBelowThreshold',
        msg: 'min_prize_pool not met',
        module: 'resolution',
    },
    UnclaimedPrizeClawbackDelayNotElapsed: {
        code: 6303,
        name: 'UnclaimedPrizeClawbackDelayNotElapsed',
        msg: 'unclaimed prize clawback delay has not elapsed while winning claim-rights supply is non-zero',
        module: 'resolution',
    },
    InsufficientClaimRights: {
        code: 6304,
        name: 'InsufficientClaimRights',
        msg: 'seller does not hold enough claim_rights_mint to cover the BC sell',
        module: 'resolution',
    },
    UnclaimedBackerFeeClawbackDelayNotElapsed: {
        code: 6305,
        name: 'UnclaimedBackerFeeClawbackDelayNotElapsed',
        msg: 'unclaimed backer-fee clawback delay has not elapsed while share supply is non-zero',
        module: 'resolution',
    },
    RemovedStandalonePrizeSweep: {
        code: 6306,
        name: 'RemovedStandalonePrizeSweep',
        msg: 'standalone prize sweep instruction has been removed',
        module: 'resolution',
    },
    ResolutionThresholdReached: {
        code: 6307,
        name: 'ResolutionThresholdReached',
        msg: 'resolution threshold reached; submit resolve_drain_and_migrate',
        module: 'resolution',
    },
    ResolutionThresholdNotReached: {
        code: 6308,
        name: 'ResolutionThresholdNotReached',
        msg: 'resolution threshold has not been reached',
        module: 'resolution',
    },
    AlreadyMigrated: {
        code: 6309,
        name: 'AlreadyMigrated',
        msg: 'market has already migrated to CP Swap',
        module: 'resolution',
    },
    WinnerLiquidityNotSeedable: {
        code: 6310,
        name: 'WinnerLiquidityNotSeedable',
        msg: 'winning bonding curve has no seedable CP Swap liquidity',
        module: 'resolution',
    },
    CrankerLpNotLocked: {
        code: 6311,
        name: 'CrankerLpNotLocked',
        msg: 'cranker LP tokens were not fully locked under market custody',
        module: 'resolution',
    },
    RemainingAccountsShapeMismatch: {
        code: 6312,
        name: 'RemainingAccountsShapeMismatch',
        msg: 'resolve_drain_and_migrate remaining accounts do not match the quote-only loser vault layout',
        module: 'resolution',
    },
    InvalidGiftAmount: {
        code: 6400,
        name: 'InvalidGiftAmount',
        msg: 'gift amount must be greater than zero',
        module: 'gift',
    },
    InvalidHandlerHash: {
        code: 6401,
        name: 'InvalidHandlerHash',
        msg: 'handler hash must not be all zeros',
        module: 'gift',
    },
    GiftAlreadyClaimed: {
        code: 6402,
        name: 'GiftAlreadyClaimed',
        msg: 'gift has already been claimed',
        module: 'gift',
    },
};
exports.OPINION_ERROR_BY_CODE = new Map(Object.values(exports.OPINION_ERRORS).map((e) => [e.code, e]));
function parseOpinionError(code) {
    return exports.OPINION_ERROR_BY_CODE.get(code);
}
function isOpinionError(code) {
    return exports.OPINION_ERROR_BY_CODE.has(code);
}
